import React from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody } from 'reactstrap';
import CollapsibleSections from '../components/CollapsibleSections';

const StaticPageSections = ({ sections, setSections, isAPP, isStatic }) => {
  const defaultPayload = {
    active: true,
    order: sections?.length + 1,
    title: '',
    slug: '',
    subTitle: '',
    articleIds: null,
    content: '',
    image: {},
    listItems: [],
  };

  const handleAddSection = () => {
    if (sections?.length === 0) {
      setSections([defaultPayload]);
      return;
    }

    const lastSection = sections[sections?.length - 1];

    if (!lastSection?.order || !lastSection?.title || !lastSection?.slug) {
      toast.error('Please fill required fields.');
      return;
    }

    setSections([...sections, defaultPayload]);
  };

  const handleRemoveSection = (index) => {
    const isConfirm = confirm('Are you sure you want to remove this section?');
    if (isConfirm) {
      setSections(sections?.filter((_, i) => i !== index));
    }
  };
  const handleDuplicateSection = (index) => {
    const isConfirm = confirm('Are you sure you want to duplicate this section?');
    if (isConfirm) {
      setSections((prevSections) => {
        const newSections = [...prevSections];
        const sectionToDuplicate = { ...newSections[index] };
        newSections.splice(index + 1, 0, sectionToDuplicate);
        return newSections;
      });
    }
  };

  const handleUpdateSection = (index, field, value) => {
    if (field === 'replace_all') {
      setSections(value);
      return;
    }

    setSections((prev) => prev?.map((section, i) => (i === index ? { ...section, [field]: value } : section)));
  };

  const handleAddItem = (sectionIndex) => {
    const currentSec = sections[sectionIndex];
    const lastItem = currentSec?.listItems[currentSec?.listItems?.length - 1];

    if (lastItem && (!lastItem?.title || !lastItem?.order)) {
      toast.error('Please fill required fields.');
      return;
    }

    const newItem = {
      active: true,
      order: '',
      title: '',
      description: '',
      image: {},
      articleIds: null,
    };
    const updatedSections = sections?.map((section, i) =>
      i === sectionIndex ? { ...section, listItems: [...section.listItems, newItem] } : section
    );
    setSections(updatedSections);
  };

  const handleDuplicateItem = (sectionIndex, itemIndex) => {
    const isConfirm = confirm('Are you sure you want to duplicate this item?');

    if (isConfirm) {
      setSections((prevSections) =>
        prevSections.map((section, i) => {
          if (i === sectionIndex) {
            const items = [...(section.listItems || [])];
            const itemToDuplicate = { ...items[itemIndex] };
            items.splice(itemIndex + 1, 0, itemToDuplicate);
            return { ...section, listItems: items };
          }
          return section;
        })
      );
    }
  };

  const handleRemoveItem = (sectionIndex, itemIndex) => {
    const isConfirm = confirm('Are you sure you want to remove this item?');

    if (isConfirm) {
      setSections((prevSections) =>
        prevSections.map((section, i) =>
          i === sectionIndex
            ? {
                ...section,
                listItems: (section.listItems || []).filter((_, j) => j !== itemIndex),
              }
            : section
        )
      );
    }
  };

  const handleUpdateItems = (sectionIndex, itemIndex, field, val) => {
    setSections((prevSections) => {
      return prevSections.map((section, i) => {
        if (i === sectionIndex) {
          return {
            ...section,
            listItems: (section.listItems || []).map((item, j) => (j === itemIndex ? { ...item, [field]: val } : item)),
          };
        }
        return section;
      });
    });
  };

  const handleToggleSectionActive = (sectionIndex, isActive) => {
    setSections((prevSections) =>
      prevSections.map((sec, i) => (i === sectionIndex ? { ...sec, active: isActive } : sec))
    );
  };

  return (
    <div className="mb-5">
      <CollapsibleSections
        sections={sections}
        handleDuplicateSection={handleDuplicateSection}
        handleRemoveSection={handleRemoveSection}
        handleUpdateSection={handleUpdateSection}
        handleAddItem={handleAddItem}
        handleDuplicateItem={handleDuplicateItem}
        handleRemoveItem={handleRemoveItem}
        handleUpdateItems={handleUpdateItems}
        handleToggleSectionActive={handleToggleSectionActive}
        isAPP={isAPP}
        isStatic={isStatic}
      />

      <Button className="mt-3" color="success" onClick={handleAddSection}>
        <i className="bx bx-plus me-2" />
        Add Section
      </Button>
      <Card className="mt-4">
        <CardBody>
          <h6>Example of Meta Data (enter in curly bracket)</h6>
          <pre>
            {JSON.stringify(
              {
                route: 'parenting-tips',
                isBlogCategoryRoute: 'parenting-tips',
                route: 'ADVERTISE_WITH_US',
                url:
                  'https://www.hindustantimes.com/education/virtual-after-school-activities-to-keep-kids-engaged-during-covid-19/story-W32bVEg0I29mzX2ucDZ4AN.html',
              },
              null,
              2
            )}
          </pre>
        </CardBody>
      </Card>
    </div>
  );
};

export default React.memo(StaticPageSections);
